<template>
  <div class="col-md-12">
    <BForm @submit.prevent="$emit('submit', { parsedPayload, chartId })">
      <BFormGroup
        label="Title"
        :invalid-feedback="getFieldError('title')"
        :state="!fieldHasError('title')"
        :aria-required="true"
      >
        <BFormInput type="text" v-model="payload.title" />
      </BFormGroup>
      <BFormGroup
        label="Datasource"
        :invalid-feedback="getFieldError('datasource')"
        :state="!fieldHasError('datasource')"
        :aria-required="true"
      >
        <Multiselect
          :options="options.datasource"
          v-model="payload.datasource"
          @input="handleDatasourceInput"
          label="label"
          track-by="name"
        />
      </BFormGroup>
      <BFormGroup
        label="ChartType"
        :invalid-feedback="getFieldError('type')"
        :state="!fieldHasError('type')"
        :aria-required="true"
      >
        <Multiselect
          :options="options.type"
          v-model="payload.type"
          label="label"
          track-by="name"
        />
      </BFormGroup>
      <BFormGroup
        label="Metrics"
        :invalid-feedback="getFieldError('metrics')"
        :state="!fieldHasError('metrics')"
        :aria-required="true"
      >
        <Multiselect
          :options="metricOptions"
          v-model="payload.metrics"
          label="label"
          track-by="name"
          :multiple="true"
        />
      </BFormGroup>
      <BFormGroup
        label="Dimensions"
        :invalid-feedback="getFieldError('dimensions')"
        :state="!fieldHasError('dimensions')"
        :aria-required="true"
      >
        <Multiselect
          :options="dimensionOptions"
          v-model="payload.dimensions"
          label="label"
          track-by="name"
          :multiple="true"
          :max="1"
        />
      </BFormGroup>
      <AdvanceFilter
        :schema="schema"
        @filterschange="handleFiltersChange"
        :saved-filters="savedFilters"
      />
      <BButton @click="$emit('cancel')" variant="danger">Cancel</BButton>
      <BButton type="submit" variant="info">Save</BButton>
    </BForm>
  </div>
</template>

<script>
import { BButton, BForm, BFormGroup, BFormInput } from "bootstrap-vue";
import Multiselect from "vue-multiselect";
import AdvanceFilter from "./Filter.vue";
import { createFilter, Operator } from "./filters";

export default {
  components: {
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    Multiselect,
    AdvanceFilter
  },
  props: {
    schemaEndpoint: {
      type: String,
      required: true
    },
    chartEndpoint: {
      type: String,
      required: true
    },
    validation: {
      type: Object,
      require: true
    },
    chartId: {
      type: Number,
      required: false
    }
  },
  created() {
    if (this.isUpdate) {
      this.$http
        .get(`${this.chartEndpoint}/${this.chartId}`)
        .then(async ({ data }) => {
          this.schema = data.schema;
          this.payload.title = data.title;
          this.payload.datasource = this.options.datasource.find(
            ({ name }) => name === data.datasource
          );
          this.payload.type = this.options.type.find(
            ({ name }) => name === data.type
          );
          this.payload.metrics = data.metrics.map(metric =>
            data.schema.find(({ name }) => name === metric)
          );
          this.payload.dimensions = data.dimensions.map(dimension =>
            data.schema.find(({ name }) => name === dimension)
          );
          this.savedFilters = data.filters.map(savedFilter => {
            const filter = createFilter();
            filter.setColumn(this.schemaKeyByField[savedFilter.field]);
            filter.setOperator(this.operatorKeyByValue[savedFilter.operator]);
            filter.value = savedFilter.value;
            return filter;
          });
        });
    }
  },
  data() {
    return {
      schemas: {},
      schema: [],
      savedFilters: [],
      filters: [],
      options: {
        datasource: [
          { name: "offers", label: "Offers" },
          { name: "applications", label: "Applications" }
        ],
        type: [
          { name: "bar", label: "Bar" },
          { name: "line", label: "Line" },
          { name: "pie", label: "Pie" },
          { name: "doughnut", label: "Doughnut" }
        ]
      },
      payload: {
        title: "",
        type: {},
        datasource: {},
        metrics: [],
        dimensions: [],
        filters: []
      }
    };
  },
  computed: {
    schemaKeyByField() {
      return this.schema.reduce((acc, column) => {
        return {
          ...acc,
          [column.name]: column
        };
      }, {});
    },
    operatorKeyByValue() {
      return Object.fromEntries(
        Object.entries(Operator).map(([, value]) => [value.value, value])
      );
    },
    isUpdate() {
      return this.chartId !== undefined;
    },
    metricOptions() {
      return this.schema.filter(field => field.is_metric);
    },
    dimensionOptions() {
      return this.schema.filter(field => field.is_dimension);
    },
    parsedPayload() {
      return {
        ...this.payload,
        type: this.payload.type.name || null,
        datasource: this.payload.datasource.name || null,
        metrics: this.payload.metrics.map(({ name }) => name),
        dimensions: this.payload.dimensions.map(({ name }) => name),
        filters: this.filters
      };
    }
  },
  methods: {
    handleFiltersChange(filters) {
      this.filters = filters;
    },
    handleDatasourceInput(input) {
      if (input.name) {
        this.fetchSchema(input.name);
        this.payload.metrics = [];
        this.payload.dimensions = [];
      }
    },
    fetchSchema(datasource) {
      if (!this.schemas[datasource]) {
        return this.$http
          .get(`${this.schemaEndpoint}/${datasource}`)
          .then(({ data }) => {
            this.schema = data;
            this.schemas[datasource] = data;
          });
      }
      this.schema = this.schemas[datasource];
    },
    handleSubmit() {},
    fieldHasError(field) {
      return this.validation[field] !== undefined;
    },
    getFieldError(field) {
      return this.validation[field] ? this.validation[field][0] : "";
    }
  }
};
</script>
